export const PHONE_TYPE = {
    MOBILE: 'MOBILE',
    HOME: 'HOME'
};
